import React from 'react'
import PropTypes from 'prop-types'
import {Text, Stack, useMultiStyleConfig, Image, Flex} from '@chakra-ui/react'
import DisplayPrice from '../../display-price'
import useProductData from '../../../hooks/use-product-data'
import {remCalc} from '../../../theme/_utils'
import Link from '@salesforce/retail-react-app/app/components/link'
import {useGoogleTagManager} from '../../../custom-api/hooks/use-google-tag-manager'
import {basic_gtm_event} from '../../../custom-api/layers/default'
import {useBooleanCustomPreference} from '../../../hooks/use-custom-preference'
import {useCurrency} from '@salesforce/retail-react-app/app/hooks'

const SearchModalProducts = ({product, index, onCloseModal, searchResults}) => {
    const {addLayer} = useGoogleTagManager()
    const searchStyles = useMultiStyleConfig('Search')
    const {productUrl, priceData} = useProductData(product)
    const notShoppableCountry = useBooleanCustomPreference('notShoppableCountry')
    const {currency} = useCurrency()

    const handleProductLayerClick = async () => {
        const cleanSearchText = (searchResults?.query || '').replace(/\*+$/, '') // Remove any trailing asterisks
        localStorage.setItem('fromISP', true)
        await addLayer(
            basic_gtm_event.bind(this, {
                event: 'internalSearch',
                eventCategory: 'engagement',
                eventAction: 'internalSearch-productClick',
                eventLabel: cleanSearchText,
                resultsAmount: searchResults?.total || 0,
            }),
        )
        onCloseModal()
    }

    return (
        <Flex
            {...searchStyles.productDetails}
            sx={{
                borderRight: {lg: index === 0 || index === 2 ? 'small' : 'none'},
                paddingRight: {base: '0', lg: index === 0 || index === 2 ? remCalc(12) : '0'},
                borderStyle: {lg: index === 0 || index === 2 ? 'solid' : 'none'},
                borderColor: {
                    lg: index === 0 || index === 2 ? 'border.light' : 'transparent',
                },
            }}
        >
            <Link to={`${productUrl}`} onClick={handleProductLayerClick}>
                <Image
                    {...searchStyles.productImage}
                    src={product.c_image?.url || product.image?.link}
                    alt={product.productName}
                />
            </Link>
            <Stack {...searchStyles.namePricing}>
                <Text {...searchStyles.productName}>
                    {product?.representedProduct?.c_variantIdentifier ||
                        product?.name ||
                        product?.productName}
                </Text>
                <DisplayPrice
                    priceData={priceData}
                    modalPrice
                    isMinicart // prop to let the suggested price display correctly
                    currency={currency}
                    showSuggestesLabel
                    variant="searchModal"
                    notShoppableCountry={notShoppableCountry}
                />
            </Stack>
        </Flex>
    )
}

SearchModalProducts.propTypes = {
    product: PropTypes.object,
    index: PropTypes.number,
    onCloseModal: PropTypes.func,
    searchResults: PropTypes.object,
}

export default SearchModalProducts
